const indexItems = [
  {
    title: '暑期档新片速递',
    desc: '本月最新上映的热门大片一网打尽',
    count: '42部',
    tag: 'hot',
    icon: 'ri-sun-line',
  },
  {
    title: '悬疑推理剧场',
    desc: '烧脑反转，高智商犯罪片合集',
    count: '68部',
    tag: 'trending',
    icon: 'ri-search-eye-line',
  },
  {
    title: '经典重温专区',
    desc: '豆瓣8.0+高分经典影片永久收藏',
    count: '156部',
    tag: '',
    icon: 'ri-vip-crown-line',
  },
  {
    title: '国产精品剧集',
    desc: '最新热播国产电视剧跟播专区',
    count: '89部',
    tag: 'new',
    icon: 'ri-tv-2-line',
  },
  {
    title: '韩剧热播频道',
    desc: '同步韩国最新热播剧集与综艺',
    count: '124部',
    tag: 'trending',
    icon: 'ri-global-line',
  },
  {
    title: '纪录片精选库',
    desc: '自然、历史、科技纪录片大全',
    count: '203部',
    tag: '',
    icon: 'ri-earth-line',
  },
  {
    title: '动漫番剧追更',
    desc: '国漫日漫同步更新，追番党必备',
    count: '315部',
    tag: 'hot',
    icon: 'ri-ghost-line',
  },
];

const tagStyles: Record<string, string> = {
  hot: 'bg-accent-500/15 text-accent-400',
  trending: 'bg-primary-500/15 text-primary-400',
  new: 'bg-green-500/15 text-green-400',
};

const tagLabels: Record<string, string> = {
  hot: '热门',
  trending: '火爆',
  new: '上新',
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            专题合集
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            精选影视专题，快速找到你想看的
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.slice(0, 4).map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 border border-background-300/30 rounded-xl p-5 hover:border-primary-500/30 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                  <i className={`${item.icon} text-lg text-primary-400`}></i>
                </div>
                {item.tag && tagStyles[item.tag] && (
                  <span className={`inline-block px-2 py-0.5 text-[11px] font-medium rounded-full ${tagStyles[item.tag]}`}>
                    {tagLabels[item.tag]}
                  </span>
                )}
              </div>
              <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors">
                {item.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 flex-1">{item.desc}</p>
              <div className="mt-3 text-xs text-primary-400 font-medium">
                共{item.count}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {indexItems.slice(4).map((item, i) => (
            <div
              key={i + 4}
              className="group bg-background-100 border border-background-300/30 rounded-xl p-5 hover:border-primary-500/30 transition-all duration-300 cursor-pointer flex items-center gap-4"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-500/10 group-hover:bg-accent-500/20 transition-colors">
                <i className={`${item.icon} text-lg text-accent-400`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-accent-400 transition-colors truncate">
                    {item.title}
                  </h3>
                  {item.tag && tagStyles[item.tag] && (
                    <span className={`inline-block px-2 py-0.5 text-[10px] font-medium rounded-full flex-shrink-0 ${tagStyles[item.tag]}`}>
                      {tagLabels[item.tag]}
                    </span>
                  )}
                </div>
                <p className="mt-1 text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <div className="text-xs text-accent-400 font-medium flex-shrink-0">
                {item.count}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}